import { FC, PropsWithChildren } from 'react';

import { Placeholder } from '@sitecore/common';

import { FlowNavigationProvider } from '../../../providers/FlowNavigationProvider';

const FlowNavigationLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <FlowNavigationProvider>
      <Placeholder name="jss-navigation-flow-be" />
      {children}
    </FlowNavigationProvider>
  );
};

export default FlowNavigationLayout;
